module.exports = __webpack_public_path__ + "52d0a814c2825642a4145bc1832032d2.svg";